import NativeSorting from './NativeSorting'

export { default } from './View'

export function install(Vue) {
  Vue.component(NativeSorting.name, NativeSorting)
}
